export default __webpack_public_path__ + "static/media/swpals-logo.3bac9bb2.svg";